export enum FedOpsInteraction {
  SubmitFiles = 'submit-files',
  ImageLoadedAfterMediaStudioSave = 'image-loaded-after-media-studio-save',
  StorageQuotaDataLoad = 'storage-quota-data-load',
  OpenUploadDialog = 'open-upload-dialog',
}
